import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldSingleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 8C2 7.44772 2.44772 7 3 7H21C21.5523 7 22 7.44772 22 8V15C22 15.5523 21.5523 16 21 16H3C2.44772 16 2 15.5523 2 15V8ZM4 9V14H20V9H4Z",
		fill: "#9C9EB6"
	})
});
export default SvgFieldSingleLine;
